var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReticle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 72,
    viewBox: "0 0 71 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-180.000000, -759.000000) translate(64.000000, 760.000000) translate(117.000000, 0.000000)",
    stroke: "#000",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    strokeLinejoin: "round",
    cx: 34.264,
    cy: 35.264,
    r: 24.264
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.456000266,35.4560003 L20.4560003,35.4560003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9560003,35.4560003 L68.9560003,35.4560003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4560003,0.456000266 L34.4560003,20.4560003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4560003,49.9560003 L34.4560003,69.9560003"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReticle);
export default __webpack_public_path__ + "static/media/reticle.134c61494879ff87b0f1520ce6f0211a.svg";
export { ForwardRef as ReactComponent };